import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { PostRequestArgsType } from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostCurrentUserPasswordPayloadType = {
  password: string;
  newPassword: string;
};

export const apiUpdateCurrentUserPassword = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostCurrentUserPasswordPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserPassword(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
